/* eslint-disable */
// Defining and Exporting a list of quotes to be displayed randomly in all screens

export const QUOTES_INSURANCE = [
  "No one can surely predict the future. But we can protect it.",
  "A Day Without Insurance is Like a Day Without Sunshine.",
  "We’re for P.P. (protecting people)",
  "You don’t need a license to live, but a way to protect it.",
  "Like a good neighbor, State Farm is there.",
  "I have good Brakes. do you have good insurance?",
  "Don’t be that ‘one’ who made the mistakes and wasn't prepared.",
  "You’re in good hands with Allstate.",
  "Security is a priority, not an option.",
  "Guarantees for the if in life.",
  "Getting better all the time.",
  "For every offense you encounter, you need someone to defend your life.",
  "Life can be limp, but we’ll help you take shape.",
  "It’s time to expect more.",
  "With a life ahead of you, the road isn’t always clear.",
  "Life Insurance is like a parachute – If you don’t have it when you need it, you will never need it again!",
  "A Finger of Insurance is Just Enough to Give Your Kids a Treat.",
  "Our rates and service are tough to beat.",
  "Trust us for the rest of your life.",
  "We Do it just a little bit better.",
  "We’re a cushion to your fall.",
  "Fifteen minutes could save you fifteen percent or more on car insurance.",
  "My Goodness, My Insurance!",
  "We’re here when you need us.",
  "Things Happen After an Insurance.",
  "Gets you back where you belong.",
  "For all the Nevers in life, State Farm is there.",
  "Tension, while you drive, can get over. Because we give you an interesting insurance cover.",
  "Don’t crash without us better than the rest auto insurance.",
  "We have thought of Crystal clear.",
  "Be prepared cause the future isn’t always crystal clear.",
  "We insure your life. Because you never know.",
  "After you die it’s too late for life insurance!",
  "24/7 Online on Life.",
  "Guarantees for the if in life.",
  "The future of life insurance.",
  "Your health, Our promise.",
  "A healthier you, a healthier community.",
  "Go ahead. Go ahead with ATI.",
  "Take a positive step.",
  "Crystal is a crystal; clear and sharp!",
  "The Insurance for All Ages.",
  "Leave the Insurance to Us.",
  "Good hands for the good life.",
  "Security is a priority, not an option.",
  "The Insurance for All Ages.",
  "Crystal is a crystal; clear and sharp!",
  "Use your breaks to meet us.",
  "We will do right by you.",
  "Don’t worry, Drive happy!",
  "It’s fast, free and secure.",
  "No worries, we’ve got you covered!",
  "All your protection under one roof.",
  "Protection for Life’s Downs.",
  "More care, less cost.",
  "Live a Long Life with Protection.",
  "We GO Where You Go.",
  "We’ll chase the recession together!",
  "We live where you live.",
  "We insure your life. Because you never know.",
  "No worries, we’ve got you covered!",
  "Protection for Life’s Downs.",
  "Don’t gamble with your life.",
  "Like a good neighbor, State Farm is there.",
  "Taking care of what’s important.",
  "Always listening, always understanding.",
  "Be life confident.",
  "New York Life. The Company You Keep.",
  "I have good brakes, do u have good insurance?",
  "Last night was great. Her name was insurance.",
  "I’m not perfect, just insured.",
  "Relax. It’s just insurance.",
  "Some coverages are longer than others.",
  "It’s big. It’s bad. It’s insurance.",
  "Everybody’s doing it. It’s called insurance.",
  "Insurance is a state of mind.",
]



// WEBPACK FOOTER //
// ./src/data/quotes.js